<template>
  <div class="bgClass">
    <div class="loginClass">
      <div style="margin-top:163px;"></div>
      <div class="logo">登入會員</div>
      <div style="width: 100%; margin-top: 21px;"></div>
      <div class="content">NuMatch，永遠「型」合你口味</div>
      <div style="width: 100%; margin-top: 30px;"></div>
      <el-form
        label-position="top"
        ref="formRef"
        :model="dynamicValidateForm"
        label-width="120px"
        class="dynamic"
        :rules="rules"
      >
        <el-form-item prop="email" :id="mailId">
          <el-input @focus="onFocuss('mail')" @blur="onBlurs('mail')" v-model="dynamicValidateForm.email" placeholder="電郵">
          </el-input>
        </el-form-item>
        <el-form-item prop="password" :id="passwordId">
          <el-input type="password" @focus="onFocuss('password')" @blur="onBlurs('password')" style="margin-top:20px;" v-model="dynamicValidateForm.password" placeholder="密碼">
          </el-input>
        </el-form-item>
        <el-form-item> </el-form-item>
        <el-form-item>
          <el-button
            id="otherBtn"
            round
            color="#6B834B"
            size="large"
            @click="submitForm"
            >登入</el-button
          >
        </el-form-item>
        <el-form-item>
          <div
            style="
              background: #ebebeb;
              margin-left: 10%;
              margin-right: 10%;
              width: 80%;
              height: 1px;
            "
          ></div>
        </el-form-item>
        <el-form-item>
          <el-button
            class="registerBtn"
            round
            color="white"
            size="large"
            @click="pushRegister"
            >創建NuMatch會員帳號</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js/crypto-js'
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import Bottom from "../components/bottom/bottom.vue";
import { logins } from "../api/index";
import Moment from 'moment'
export default {
  name: "App",
  components: {
    Bottom,
  },
  setup() {
    const userRouter = useRouter();
    onMounted(() => {});

    const formRef = ref(null);
    const dynamicValidateForm = ref({
      name: "",
      email: "",
      password: "",
    });
    const pushRegister = () => {
      userRouter.push({
        path: "/register",
        query: {},
      });
    };

    const validateMail = (rule, value, callback)=>{
      if (value === '') {
        return true
      } else {
        // eslint-disable-next-line no-useless-escape
        if (/^[\w\.-]+@[a-z0-9\-]+(\.[a-z]{2,6}){1,3}$/i.test(value) === false) {
          callback(new Error('請輸入正確電郵'))
        }else {
          return true
          
        }
      }
    };

    const rules = {
      email: [
        {required: true, validator: validateMail, trigger: 'blur' }
      ],
      password: [{ min: 8, max: 16, message: '密碼必須8-16個字', trigger: 'blur' }]
    };
    const submitForm = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          if (dynamicValidateForm.value.email == '') {
            ElMessage.error('請輸入正確電郵')
            return
          }
          if (dynamicValidateForm.value.password == '') {
            ElMessage.error('請輸入密碼')
            return
          }
          var key = CryptoJS.enc.Utf8.parse('passwordpassword')
    var encryptResult = CryptoJS.AES.encrypt(dynamicValidateForm.value.password, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
          logins({
            username: dynamicValidateForm.value.email,
            password: encryptResult,
            grant_type: "password",
            client_id: "isung",
            useEncrypt:true,
            client_secret: "isung2022",
            channel: "USER",
            platform :"GATEWAY",
            timestamp: Moment(new Date()).valueOf()
          }).then((res) => {
            if (res.errCode === 200) {
              ElMessage.success("登入成功");
              let a = 'Bearer ' + res.data.value
              window.localStorage.setItem('AIOrderIndex', JSON.stringify(res.data.additionalInformation))
              localStorage.setItem("AIIndex_Token", JSON.stringify(a))
              userRouter.push({
                path: '/update',
                query: {},
              });
            } else {
              ElMessage.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    };

    const onFocuss = (event) => {
      if (event == 'mail') {
        mailId.value = 'form-mails'
      }else{
        passwordId.value = 'form-passwords'
      }
    };
    const onBlurs = (event) => {
      if (event == 'mail') {
        mailId.value = 'form-mail'
      }else {
        passwordId.value = 'form-password'
      }
    };
    const passwordId = ref('form-password')
    const mailId = ref('form-mail')

    return {
      onBlurs,
      onFocuss,
      mailId,
      passwordId,
      validateMail,
      rules,
      submitForm,
      userRouter,
      pushRegister,
      formRef,
      dynamicValidateForm,
    };
  },
};
</script>

<style lang="less" scoped>
.bgClass {
  width: 100%;
  height: 100%;
  min-height: 700px;
  display: flex;

  flex-direction: column;
  justify-content: space-between;
}
.loginClass {
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.logo {
  font-size: 57px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
}
.content {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
}
.loginGoogle {
  width: calc(100% / 1080 * 259);
  aspect-ratio: 259 / 27;
  background: #0d5bba;
  border-radius: 5px;
}
.dynamic {
  width: calc(100% / 1080 * 259);
}
.logoTitle {
  font-size: 32px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 42px;
}
.content_sub {
  font-size: 10px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 16px;
}
:deep(.el-input) {
  width: 100%;
  aspect-ratio: 259 / 32 !important;
  --el-input-focus-border-color: rgba(0,0,0,0);
  --el-input-hover-border-color: rgba(0,0,0,0);
  --el-input-clear-hover-color:rgba(0,0,0,0);
}

#otherBtn {
  width: 470px;
  height: 65px;
  border-radius: 33px !important;
}
.inputName {
  font-size: 13px;
  height: 40px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .redSpan {
    margin-left: 5px;
    margin-top: -5px;
    color: #f00404;
  }
}

.registerBtn {
  width: 470px;
  height: 65px;
  border-radius: 33px !important;
  border-color: #0d5bba;
  :deep(span) {
    color: #0d5bba;
  }
}
.registerBtn:hover {
  width: 470px;
  height: 65px;
  border-radius: 33px !important;
  border-color: #0d5bba;
  :deep(span) {
    color: #0d5bba;
  }
}
:deep(.el-form-item__error) {
  margin-top: 10px;
  margin-bottom:10px;
  font-size: 13px;
}

:deep(.el-input__inner::placeholder){
  font-size: 10px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 14px;
}

#form-mails{
    :deep(.el-input__wrapper){
      border: 1px solid #6B834B;
    }
}
#form-mail{
  :deep(.el-input__wrapper){
    border: 1px solid #cdcdcd;
  }
}
#form-passwords{
    :deep(.el-input__wrapper){
      border: 1px solid #6B834B;
    }
}
#form-password{
  :deep(.el-input__wrapper){
    border: 1px solid #cdcdcd;
  }
}

:deep(.el-input__wrapper) {
  box-shadow: none;
  border: 1px solid #cdcdcd;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

</style>